(function(root, factory) {
	if (typeof define === 'function' && define.amd) {
		define('ensureDate/ensureDate',['require','exports','module'],function(require, exports, module) {
			module.exports = factory();
		});
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.bamEnsureDate = factory();
	}
}(this, function() {
	return function (value) {
	    var date = typeof value !== 'undefined' ? value instanceof Date ? value : new Date(value) : new Date();
	    if (isNaN(date.getTime())) {
	      throw 'ensureDate: Invalid date';
	    }
	    return date;    
	}
}));
